import React from "react";

const LoaderSingleSimulation = () => {
    return(
        <div className="loader_single_simulation_cont">
            <div className="loader_single_simulation_cont_item">
                <div className="loader_single_simulation_cont_item_row">
                    <div className="loader_single_simulation_cont_item_row_cell fade-in"></div>
                    <div className="loader_single_simulation_cont_item_row_cell fade-in"></div>
                </div>
                <div className="loader_single_simulation_cont_item_row">
                    <div className="loader_single_simulation_cont_item_row_cell fade-in"></div>
                    <div className="loader_single_simulation_cont_item_row_cell fade-in"></div>
                </div>
            </div>
            <div className="loader_single_simulation_cont_item_body fade-in"></div>
            <div className="loader_single_simulation_cont_item_sw">
                <div className="loader_single_simulation_cont_item_sw_item fade-in"></div>
                <div className="loader_single_simulation_cont_item_sw_item fade-in"></div>
            </div>
            <div className="loader_single_simulation_cont_item_body fade-in"></div>
        </div>
    )
}

export default LoaderSingleSimulation